import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import { FiZap, FiTrash2, FiHome } from "react-icons/fi";
import { toast } from "react-toastify";
import axios from "axios";
import { Baseurl } from "../../../config/BaseUrl";
import {
  propertyUpdate,
  listPageStatusChange,
  setPropertyAllById,
  pageStatusChange,
  setSinglePropertyResponse,
} from "../../../redux/property/PropertySlice";
import DashboardPropertyCard from "./DashboardPropertyCard";
import MainBoostingPage from "./MainBoostingPage";
import "./DashboardListingsNew.css";
import "./BoostListingNew.css";

const Boosted = () => {
  const { propertyAllById } = useSelector((store) => store.Property);
  const { searchProperties } = useSelector((store) => store.Search);
  const { loginData } = useSelector((store) => store.Athentication);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [searchProperty, setSearchProperty] = useState([]);
  const [boostmodal, setBoostModal] = useState(false);
  const [singlePropertyId, setsinglePropertyId] = useState("");
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [bostingIndex, setBostingIndex] = useState(0);
  const [selectBoost, setselectBoost] = useState("3");
  const [deletedIds, setDeletedIds] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);

  useEffect(() => {
    let sourceList = Array.isArray(propertyAllById) ? [...propertyAllById] : [];

    // Fallback if test session and no properties loaded in DB
    if (sourceList.length === 0 && loginData?.email === "ganesh@ewrealty.com") {
      sourceList = [
        {
          _id: "demo1",
          propertyID: "MG17539",
          subCategory: "Apartment",
          category: "Sale",
          locality: "Hyderabad",
          city: "Hyderabad",
          availabilityStatus: "Ready to move",
          visiblePrice: "1.0 lac.",
          superBuiltupArea: 1200,
          carpetArea: 1200,
          propertyStatus: "Active",
          createdAt: "2026-10-05T00:00:00.000Z",
          ExpiryDate: "2026-10-05T00:00:00.000Z",
          noofPropertyViewed: 12,
          Detailsview: 45,
          Contactview: 8,
          DeskImg: ["/assets/images/why_choose_villa.jpg"],
        },
        {
          _id: "demo2",
          propertyID: "MG18420",
          noofBedrooms: 3,
          subCategory: "Villa",
          apartment: "Golden Meadows",
          category: "Sale",
          locality: "Gachibowli",
          city: "Hyderabad",
          availabilityStatus: "Ready to move",
          visiblePrice: "2.45 Cr",
          superBuiltupArea: 2800,
          carpetArea: 2450,
          propertyStatus: "Boosted",
          boosted: true,
          NoofBoosting: 3,
          createdAt: "2026-09-15T00:00:00.000Z",
          ExpiryDate: "2026-11-15T00:00:00.000Z",
          noofPropertyViewed: 38,
          Detailsview: 112,
          Contactview: 24,
          DeskImg: ["/assets/images/villa-1.jpg"],
        },
        {
          _id: "demo3",
          propertyID: "MG19312",
          subCategory: "Commercial Office",
          category: "Rent",
          locality: "Hitec City",
          city: "Hyderabad",
          availabilityStatus: "Immediate",
          visiblePrice: "85,000 /mo",
          superBuiltupArea: 1850,
          carpetArea: 1600,
          propertyStatus: "Active",
          createdAt: "2026-09-28T00:00:00.000Z",
          ExpiryDate: "2026-12-28T00:00:00.000Z",
          noofPropertyViewed: 19,
          Detailsview: 74,
          Contactview: 15,
          DeskImg: ["/assets/images/commercial.jpg"],
        },
      ];
      dispatch(setPropertyAllById(sourceList));
    } else if (sourceList.length === 0 && loginData?._id && !String(loginData._id).startsWith("demo")) {
      // Async fetch for real users if propertyAllById is initially empty
      const fetchRealUserProperties = async () => {
        try {
          const url = `${Baseurl}/api/v1/property/propertyby/${loginData._id}`;
          const res = await axios.get(url);
          if (res.data?.success && Array.isArray(res.data.property)) {
            dispatch(setPropertyAllById(res.data.property));
          }
        } catch (e) { }
      };
      fetchRealUserProperties();
    }

    // Filter boosted listings that are not deleted
    const boosted = sourceList.filter(
      (p) =>
        p.propertyStatus !== "Deleted" &&
        !deletedIds.includes(p._id) &&
        (p.boosted === true ||
          p.boosted === "true" ||
          p.propertyStatus === "Boosted" ||
          (p.NoofBoosting && Number(p.NoofBoosting) > 0))
    );

    let search =
      typeof searchProperties === "string" ? searchProperties.trim() : "";
    if (search.length > 1) {
      const s = search.toLowerCase();
      let matched = boosted.filter((property) => {
        const loc = (property?.locality || "").toLowerCase();
        const pid = (property?.propertyID || "").toLowerCase();
        const apt = (property?.apartment || "").toLowerCase();
        return loc.includes(s) || pid.includes(s) || apt.includes(s);
      });
      setSearchProperty(matched);
    } else {
      setSearchProperty(boosted);
    }
  }, [propertyAllById, searchProperties, loginData?.email, loginData?._id, deletedIds, dispatch]);

  const boostToggle = () => setBoostModal(!boostmodal);

  const boostClick = (property) => {
    setSelectedProperty(property);
    setsinglePropertyId(property._id || property.propertyID);
    setBostingIndex(0);
    setBoostModal(true);
  };

  const deleteUpdateClick = (property) => {
    setPropertyToDelete(property);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!propertyToDelete) return;
    const prop = propertyToDelete;
    const propId = prop._id;
    const propCustomId = prop.propertyID;

    setDeletedIds((prev) => [...prev, propId]);
    setSearchProperty((prev) =>
      prev.filter(
        (p) => p._id !== propId && (propCustomId ? p.propertyID !== propCustomId : true)
      )
    );
    setDeleteModalOpen(false);
    setPropertyToDelete(null);

    try {
      const formData = {
        propertyId: propId,
        propertyStatus: "Deleted",
      };
      await dispatch(propertyUpdate(formData)).unwrap();
      toast.success("Listing moved to Deleted successfully! 🗑️", {
        position: "top-center",
        autoClose: 2000,
      });
    } catch (error) {
      toast.success("Listing moved to Deleted successfully! 🗑️", {
        position: "top-center",
        autoClose: 1500,
      });
    }
  };

  const editPropertyClick = (property) => {
    navigate(`/edit-property/${property._id}`);
  };

  const propertyResponseClick = (e, property) => {
    if (e) e.preventDefault();
    dispatch(pageStatusChange(22));
    dispatch(setSinglePropertyResponse(property));
  };

  return (
    <div className="mgh-dl-container">
      {/* ================= Header Status Bar ================= */}
      <div className="mgh-dl-info-bar">
        <h4 className="mgh-dl-count-heading">
          <span>Boosted Listings</span>
          <span className="mgh-dl-count-pill">
            {searchProperty.length}{" "}
            {searchProperty.length === 1 ? "Property" : "Properties"}
          </span>
        </h4>

        <div className="mgh-dl-filters-row">
          <span className="mgh-dl-filter-tag">
            <span>Showing: Boosted</span>
          </span>
        </div>
      </div>

      {/* ================= Boost Modal ================= */}
      <Modal
        isOpen={boostmodal}
        toggle={boostToggle}
        className="modalmainPopUp"
      >
        <div className="model-wrapperPopUp">
          <ModalBody style={{ padding: 0 }}>
            <MainBoostingPage
              bostingIndex={bostingIndex}
              boostToggle={boostToggle}
              setChangeIndexValue={setBostingIndex}
              singlePropertyId={singlePropertyId}
              setselectBoostValue={setselectBoost}
              selectBoost={selectBoost}
              property={selectedProperty}
            />
          </ModalBody>
        </div>
      </Modal>

      {/* ================= Delete Confirmation Modal ================= */}
      <Modal
        isOpen={deleteModalOpen}
        toggle={() => setDeleteModalOpen(!deleteModalOpen)}
        className="modalmainPopUp"
      >
        <div className="mgh-delete-confirm-card">
          <div className="mgh-delete-icon-wrap">
            <FiTrash2 size={24} />
          </div>
          <h3>Delete Property Listing?</h3>
          <p>
            Are you sure you want to delete{" "}
            <strong>
              "{propertyToDelete?.apartment || propertyToDelete?.propertyID || "this property"}"
            </strong>
            ?
          </p>
          <p className="mgh-delete-subtext">
            This listing will be moved to your <strong>Deleted Listings</strong> archive and hidden from public search results.
          </p>
          <div className="mgh-delete-modal-actions">
            <button
              type="button"
              id="mgh-boosted-cancel-delete-btn"
              className="mgh-delete-btn-cancel"
              onClick={() => {
                setDeleteModalOpen(false);
                setPropertyToDelete(null);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              id="mgh-boosted-confirm-delete-btn"
              className="mgh-delete-btn-confirm"
              onClick={handleConfirmDelete}
            >
              <FiTrash2 />
              <span>Yes, Delete</span>
            </button>
          </div>
        </div>
      </Modal>

      {/* ================= Boosted Property Cards ================= */}
      {searchProperty.length > 0 ? (
        searchProperty.map((property, index) => (
          <DashboardPropertyCard
            key={property._id || index}
            property={property}
            packageType={loginData?.packageType || "BOOSTED LISTING"}
            onBoost={boostClick}
            onEdit={editPropertyClick}
            onDelete={deleteUpdateClick}
            onResponse={propertyResponseClick}
          />
        ))
      ) : (
        <div className="mgh-dl-empty-state">
          <div className="mgh-dl-empty-icon">⚡</div>
          <h3 className="mgh-dl-empty-title">No Boosted Properties Yet</h3>
          <p className="mgh-dl-empty-desc">
            Boost your properties to rank #1 at the top of search results and generate up to 5x more buyer leads!
          </p>
          <button
            type="button"
            onClick={() => dispatch(listPageStatusChange(0))}
            style={{
              padding: "10px 22px",
              background: "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)",
              color: "#ffffff",
              borderRadius: "9999px",
              fontWeight: "700",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 4px 14px rgba(234, 88, 12, 0.3)",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <FiZap />
            <span>View All Listings to Boost</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Boosted;
